<template>
	<div id="dashboard-sidebar">
		<ul>
			<li>
				<a href="/home">
					Dashboard Home
				</a>
			</li>
			<li>
				<a href="/dropdowns/">
					Manage Dropdowns
				</a>
			</li>
			<li>
				<a href="/banner/">
					Manage Banner
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
import LocaleDropdown from "./LocaleDropdown";

export default {
	name: "DashboardSidebar",

	components: {
		LocaleDropdown
	},

	data: () => ({
		appName: window.config.appName
	})
};
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/DashboardSidebar.vue